module.exports = __webpack_public_path__ + "img/ill-home-services-seo.503396b2.svg";